import { GetProfileMedicationsDtoStatusEnum } from 'woofwoof-api';
import { mapMedicationStatusToString } from 'src/utils/mapMedicationStatusToString';
import Iconify from '../iconify';
import Label from '../label';

interface MedicationStatusBadgeProps {
  status?: GetProfileMedicationsDtoStatusEnum;
}

/**
 * Built like `VisitStatusBadge`, deliberately: a status reads the same
 * wherever it appears in the dashboard, so a soft label with an icon is what
 * a professional's eye is already trained on.
 */
export default function MedicationStatusBadge({
  status,
}: MedicationStatusBadgeProps) {
  const statusInfo = mapMedicationStatusToString(status);

  if (!statusInfo) {
    return null;
  }

  return (
    <Label
      variant="soft"
      color={statusInfo.color}
      sx={{ textTransform: 'none', width: 'fit-content' }}
      startIcon={<Iconify icon={statusInfo.icon || ''} />}
      data-testid="medication-status-chip"
    >
      {statusInfo.label}
    </Label>
  );
}
